export default __webpack_public_path__ + "static/media/YAS0050.34I-27670_-26229_0.892bb428.jpg";